module.exports = __webpack_public_path__ + "static/media/slider3.1070d9c8.jpg";